import styled from 'styled-components';
import {
  cssColorValue,
  gray90,
  spacer12,
  spacer48,
  spacer8,
  Tag,
  Type,
} from '@spotify-internal/encore-web';

const Container = styled.div<{ backgroundColor?: string }>`
  display: flex;
  align-items: center;
  height: ${spacer48};
  border-bottom: solid 1px ${gray90};
  background-color: ${({ backgroundColor }) =>
    backgroundColor === 'backgroundHighlight'
      ? cssColorValue('backgroundHighlight')
      : ''};
  margin-bottom: 2px;
`;

const Label = styled(Type)`
  width: 200px;
  padding-left: ${spacer12};
  padding-right: ${spacer8};
`;

const LabelTextOverflow = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const LabelValueOverflow = styled(Type)`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Value = styled.div`
  flex: 1;
  width: 160px;
  padding-left: ${spacer12};
`;

interface PillInfoWithIconProps {
  label: string;
  value: React.ReactNode;
  tagText?: string | undefined;
  icon: JSX.Element;
  backgroundColor?: 'backgroundHighlight';
  subduedValueTextColor?: 'textSubdued';
}

export const PillInfoWithIcon = ({
  label,
  value,
  tagText,
  icon,
  backgroundColor,
  subduedValueTextColor,
}: PillInfoWithIconProps) => {
  return (
    <Container backgroundColor={backgroundColor}>
      <Label variant="viola" semanticColor="textSubdued">
        <LabelTextOverflow>{label}</LabelTextOverflow>
      </Label>
      <Value>
        <Flex>
          <LabelValueOverflow
            variant="viola"
            semanticColor={subduedValueTextColor}
          >
            {value}
          </LabelValueOverflow>
          <Flex>
            {tagText && <Tag>{tagText}</Tag>}
            {icon}
          </Flex>
        </Flex>
      </Value>
    </Container>
  );
};
